import { Dropdown } from 'antd';
import { Icon as CroplerIcon, Button } from '@cropler/ui-kit';
import styles from '../styles.module.scss';
import stylesDropdownMenu from '../../../styles/dropdownMenu.module.scss';

const AddSeasonMenu = ({ t, onPickMap, onCreateManually }) => {
  return (
    <Dropdown
      menu={{
        items: [
          {
            key: '1',
            label: (
              <Button type="default" className={stylesDropdownMenu.dropdownMenuLink} onClick={() => onPickMap()}>
                <CroplerIcon name="pinOnMap" />
                <span>{t('fields.menu.pickOnMap')}</span>
              </Button>
            ),
          },
          {
            key: '2',
            label: (
              <Button type="default" className={stylesDropdownMenu.dropdownMenuLink} onClick={onCreateManually}>
                <CroplerIcon name="border" />
                <span>{t('fields.menu.createManually')}</span>
              </Button>
            ),
          },
        ],
      }}
    >
      <span>
        <Button className={styles.fieldItemAdd} type="text" size="small" icon={<CroplerIcon name="add" />}>
          {t('fields.buttonNewSeason')}
        </Button>
      </span>
    </Dropdown>
  );
};

export default AddSeasonMenu;
